import api from 'common/api';

export const getFilterShipAPI = (params: any) => api.get('/ship-status/search', params);

export const updateFilterShipAPI = (params: any) => api.post('/ship-status/update', params);

export const uploadShipMoveInfoAPI = (params: any) => api.post('/ship-move-info-upload/file', params);
